import queryString from 'query-string'

export default {
  watch: {
    id () {
      this.getData()
    },
    version () {
      this.getData()
    }
  },
  mounted () {
    this.getData()
    document.addEventListener('keydown', this.keyDownEvent)
  },
  methods: {
    documentUrl (id, version, fileIndex, params = {}) {
      params.token = this.$api.defaults.headers.common['Authorization'].substr(7)
      const url = `${this.$api.defaults.baseURL}inv/documents/${id}/${version}/${fileIndex}/?${queryString.stringify(params)}`
      return url
    },

    documentBase64 (id, version, fileIndex, params = {}) {
      params.token = this.$api.defaults.headers.common['Authorization'].substr(7)
      const data = `${this.$api.defaults.baseURL}inv/documents/${id}/${version}/${fileIndex}/?${queryString.stringify(params)}`
      return data
    },

    downloadDocument (id, version, fileIndex, params = {}, fileName) {
      // Document is now read
      this.$store.dispatch('addDocument', this.id)

      params['download'] = true
      params['filename'] = fileName

      params.download = true

      const url = this.documentBase64(id, version, fileIndex, params)

      window.open(url)
    },

    async getData () {
      this.$store.dispatch('addDocument', this.id)
    }
  },
}
